import { LoadingStatusEnum } from '../../../../store/types'
import { SortDirectionCapital } from '../../../../types'
import { getInitialPaginationDataFromKeys } from '../../../../utils'
import {
  CommissionBenchmarkAccountBreakdownItem,
  CommissionBenchmarkAccountOverviewItem,
  CommissionBenchmarkOverviewColumnsEnum,
  CommissionBenchmarkOverviewPagination,
  CommissionBenchmarkReferenceResponse,
} from '../api/types'
import { DetailSortOption } from '../components/AccountDetailsTable'

export type AccountDetailState = {
  data: CommissionBenchmarkAccountBreakdownItem[]
  loading: LoadingStatusEnum
  error: string | null
  onlyWorse: boolean
  sortBy: DetailSortOption
  loaded: boolean
}

export type OverviewFilters = {
  showDemo: boolean
  showProp: boolean
  showCfd: boolean
  onlyWorseThanNuvesto: boolean
}

export type OverviewFilterKey = keyof OverviewFilters

export const createDefaultDetailState = (): AccountDetailState => ({
  data: [],
  loading: LoadingStatusEnum.Idle,
  error: null,
  onlyWorse: false,
  sortBy: 'totalDifference',
  loaded: false,
})

const overviewColumns = [
  CommissionBenchmarkOverviewColumnsEnum.totalSymbols,
  CommissionBenchmarkOverviewColumnsEnum.symbolsWorseThanNuvesto,
  CommissionBenchmarkOverviewColumnsEnum.maxCommissionDeviation,
  CommissionBenchmarkOverviewColumnsEnum.totalCommissionPaid,
  CommissionBenchmarkOverviewColumnsEnum.totalNuvestoCommissionPaid,
  CommissionBenchmarkOverviewColumnsEnum.totalCommissionDifference,
  CommissionBenchmarkOverviewColumnsEnum.totalCombinedDifference,
]

const initialState = {
  reference: null as CommissionBenchmarkReferenceResponse | null,
  referenceLoading: LoadingStatusEnum.Idle,
  referenceError: null as string | null,
  overview: [] as CommissionBenchmarkAccountOverviewItem[],
  overviewLoading: LoadingStatusEnum.Idle,
  overviewError: null as string | null,
  overviewRequestId: null as string | null,
  overviewPagination: {
    ...getInitialPaginationDataFromKeys(overviewColumns),
    order: SortDirectionCapital.desc,
    orderBy: CommissionBenchmarkOverviewColumnsEnum.totalCombinedDifference,
  } as CommissionBenchmarkOverviewPagination,
  expandedAccounts: [] as number[],
  details: {} as Record<number, AccountDetailState>,
  overviewFilters: {
    showDemo: true,
    showProp: true,
    showCfd: true,
    onlyWorseThanNuvesto: true,
  } as OverviewFilters,
}

export type StateType = typeof initialState

export default initialState
